import type { Chain } from '../../../chain';
import { splitWalletProviderKey } from '../../walletProvider/splitWalletProviderKey';
import { normalizeAddress } from '../normalizeAddress';

type CreateWalletAccountIdParams = {
  address: string;
  chain: Chain;
  walletProviderKey: string;
};

/** @notInstrumented */
export const formatWalletAccountId = ({
  address,
  chain,
  walletProviderKey,
}: CreateWalletAccountIdParams): string => {
  const { normalizedWalletNameWithChain } =
    splitWalletProviderKey(walletProviderKey);

  const normalizedAddress = normalizeAddress({ address, chain });

  return `${normalizedWalletNameWithChain}:${normalizedAddress}`;
};
